export default __webpack_public_path__ + "static/email-62fa976507e6dc0464f708d783f1482a.png";